import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authenticated client — sends session cookies for admin/auth flows.
export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Public client — no credentials. Used for public endpoints (newsletter, posts,
// events, public meta) so the browser accepts wildcard CORS responses from the
// edge, which strips the per-origin header on cached POSTs.
const publicApi = axios.create({
    baseURL: API,
    withCredentials: false,
});

export const Meta = {
    get: () => publicApi.get("/meta").then((r) => r.data),
};

export const Newsletter = {
    subscribe: (payload) =>
        publicApi.post("/newsletter/subscribe", payload).then((r) => r.data),
    communityClick: (email) =>
        publicApi
            .post("/newsletter/community-click", { email })
            .then((r) => r.data),
    posts: () => publicApi.get("/newsletter/posts").then((r) => r.data),
    createPost: (p) => api.post("/newsletter/posts", p).then((r) => r.data),
    deletePost: (id) =>
        api.delete(`/newsletter/posts/${id}`).then((r) => r.data),
    subscribers: () =>
        api.get("/newsletter/subscribers").then((r) => r.data),
};

export const YouTubeApi = {
    list: () => publicApi.get("/youtube/videos").then((r) => r.data),
    add: (p) => api.post("/youtube/videos", p).then((r) => r.data),
    remove: (id) => api.delete(`/youtube/videos/${id}`).then((r) => r.data),
    sync: () => api.post("/youtube/sync").then((r) => r.data),
};

export const Events = {
    list: () => publicApi.get("/events").then((r) => r.data),
    create: (p) => api.post("/events", p).then((r) => r.data),
    remove: (id) => api.delete(`/events/${id}`).then((r) => r.data),
};

export const Booking = {
    slots: () => publicApi.get("/booking/slots").then((r) => r.data),
    allSlots: () => api.get("/booking/slots/all").then((r) => r.data),
    createSlot: (p) => api.post("/booking/slots", p).then((r) => r.data),
    deleteSlot: (id) =>
        api.delete(`/booking/slots/${id}`).then((r) => r.data),
    checkout: (p) => publicApi.post("/booking/checkout", p).then((r) => r.data),
    status: (sid) => publicApi.get(`/booking/status/${sid}`).then((r) => r.data),
    bookings: () => api.get("/bookings").then((r) => r.data),
};

export const Settings = {
    get: () => publicApi.get("/settings").then((r) => r.data),
    update: (p) => api.put("/settings", p).then((r) => r.data),
};

export const Auth = {
    me: () => api.get("/auth/me").then((r) => r.data),
    session: (session_id) =>
        api.post("/auth/session", { session_id }).then((r) => r.data),
    logout: () => api.post("/auth/logout").then((r) => r.data),
};
